import styled from '@emotion/styled';

export const EmptyState = styled.div`
  padding: var(--spacing-16);
  font: var(--font-body-l-light);
`;
